import { Box, MenuItem, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField,
  Typography, Accordion, AccordionSummary, AccordionDetails
} from '@mui/material'
import React, { useRef, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation'
import { Colors } from '../../../../Styles/Colors'
import ShowComponents from '../../DoctorNotes/Common/ShowComponent'
import { COMMON_STYLE } from '../../../../Utility/Constants'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const vitalState = {
  patient_details: {},
  clinic_id: '',
  appointment_id: '',
  patient_id: '',
  vitalData: [],
  loadScreen: false,
  accordionOpen: false,
}

const avoidKey = new Set(["id", "appointment_id", "temperature_unit", "patient_id", "vital_entered_time", "head_circumference", "bmi", ])

const UmaDocVitals = React.forwardRef((data, ref) => {
  const [vitals, setVitals] = useState(vitalState)
  const changedRef = useRef(false)
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - VITALS`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - VITALS`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  React.useImperativeHandle(ref, () => ({
    performVitalsAction: () => {
      if (JSON.stringify(vitals.vitalData) !== vitals.dupVitals) {
        postPatientVitalsData()
      }
    }
  }))

  const apiCalls = async () => {
    await Promise.all([getPatientVitalsData()])
  }

  const hasValue = obj => Object.entries(obj)
    .some(([key, value]) => !avoidKey.has(key) && value);

  const getPatientVitalsData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_VITALS + `?appointment_id=${data?.props?.appointment_id}&doctor_id=${data?.props?.doctorID}`);
      if (response.data.status === 'success') {
        let obj = {
          "id": '', "appointment_id": '', "height_cm": '', "weight_kg": '', "bmi": '',
          "blood_pressure_systolic": '', "blood_pressure_diastolic": '', "temperature": '', "temperature_unit": "F",
          "pulse_oximetry": '', "blood_sugar": '', "pulse_rate": '', "head_circumference": ''
        }
        setVitals((prev) => ({
          ...prev,
          vitalData: response.data.data?.length > 0 ? response.data.data : [obj],
          dupVitals: response.data.data?.length > 0 ? JSON.stringify(response.data.data) : JSON.stringify([obj]),
          loadScreen: true,
          accordionOpen: response.data.data?.length > 0 ? hasValue(response.data.data[0]) : false
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message);
      } else {
        errorMessage(error.message);
      }
    }
  }

  const postPatientVitalsData = async () => {
    try {
      let state = vitals.vitalData
      let list = {
        id: state[0]?.id ? state[0]?.id : null,
        appointment_id: data?.props?.appointment_id ? +data?.props?.appointment_id : null,
        height_cm: state[0]?.height_cm ? +state[0]?.height_cm : 0,
        weight_kg: state[0]?.weight_kg ? +state[0]?.weight_kg : 0,
        bmi: (state[0]?.height_cm && state[0]?.weight_kg && state[0]?.bmi) ? state[0]?.bmi : 0,
        blood_pressure_systolic: state[0]?.blood_pressure_systolic ? +state[0]?.blood_pressure_systolic : 0,
        blood_pressure_diastolic: state[0]?.blood_pressure_diastolic ? state[0]?.blood_pressure_diastolic : 0,
        temperature: state[0]?.temperature ? +state[0]?.temperature : 0,
        temperature_unit: state[0]?.temperature_unit ? state[0]?.temperature_unit : 'F',
        pulse_oximetry: state[0]?.pulse_oximetry ? +state[0]?.pulse_oximetry : 0,
        blood_sugar: state[0]?.blood_sugar ? +state[0]?.blood_sugar : 0,
        pulse_rate: state[0]?.pulse_rate ? +state[0]?.pulse_rate : 0,
        head_circumference: state[0]?.head_circumference ? state[0]?.head_circumference : 0
      }
      const response = await RestAPIService.create(list, Serviceurls.NEW_DOC_NOTES_VITALS);
      if (response.data.status === 'success') {
        successMessage(response.data.message)
        await getPatientVitalsData()
        changedRef.current = false
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message);
      } else {
        errorMessage(error.message);
      }
    }
  }

  const calculateBMI = (weight, height) => {
    height = +height / 100;
    const bmi = +weight / ((+height) * (+height));
    return bmi;
  }

  const onChangeHandler = (e, key, index) => {
    try {
      let value = e.target.value
      let num = CommonValidation.DecimalNumber(value)
      setVitals((prev) => {
        let vitalData = [...prev.vitalData]
        switch (key) {
          case "height_cm":
            if ((num && value >= 1 && value <= 230) || value === "") {
              vitalData[index] = { ...vitalData[index], height_cm: value, bmi: calculateBMI(vitalData[index]?.weight_kg, value)?.toFixed(2) }
            }
            break;
          case "weight_kg":
            if ((num && value >= 1 && value <= 500) || value === "") {
              vitalData[index] = { ...vitalData[index], weight_kg: value, bmi: calculateBMI(value, vitalData[index]?.height_cm)?.toFixed(2) }
            }
            break;
          case "blood_pressure_diastolic":
            if ((num && value >= 1 && value <= 200) || value === "") {
              vitalData[index] = { ...vitalData[index], blood_pressure_diastolic: value }
            }
            break;
          case "blood_pressure_systolic":
            if ((num && value >= 1 && value <= 250) || value === "") {
              vitalData[index] = { ...vitalData[index], blood_pressure_systolic: value }
            }
            break;
          case "temperature":
            if ((vitalData[index]['temperature_unit'] === "F" && num && value >= 1 && value <= 248) || value === "") {
              vitalData[index] = { ...vitalData[index], temperature: value }
            } else if ((vitalData[index]['temperature_unit'] === "C" && num && value >= 1 && value <= 200) || value === "") {
              vitalData[index] = { ...vitalData[index], temperature: value }
            }
            break;
          case "pulse_oximetry":
            if ((num && value >= 1 && value <= 100) || value === "") {
              vitalData[index] = { ...vitalData[index], pulse_oximetry: value }
            }
            break;
          case "pulse_rate":
            if ((num && value >= 1 && value <= 150) || value === "") {
              vitalData[index] = { ...vitalData[index], pulse_rate: value }
            }
            break;
          case "blood_sugar":
            if ((num && value >= 1 && value <= 500) || value === "") {
              vitalData[index] = { ...vitalData[index], blood_sugar: value }
            }
            break;
          case "head_circumference":
            if ((num && value >= 1 && value <= 56) || value === "") {
              vitalData[index] = { ...vitalData[index], head_circumference: value }
            }
            break;
          default:
            vitalData[index] = { ...vitalData[index], [key]: value }
            break;
        }
        changedRef.current = true
        return { ...prev, vitalData }
      })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const textBox = (names, values, width, endAdornment, index) => {
    try {
      return (
        <TextField
          disabled={data?.props?.patient_transfered || data?.props?.isLocked}
          autoComplete='off'
          size='small'
          value={values}
          sx={{ width: width }}
          onChange={(e) => onChangeHandler(e, names, index)}
          InputProps={{
            emed_tid: names,
            style: { height: COMMON_STYLE.HEIGHT },
            endAdornment: <Typography fontSize={'0.8vw'} fontWeight={600} color={Colors.SecondaryText}>{endAdornment}</Typography>
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              postPatientVitalsData()
            }
          }}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apiCalls}>
      <Box component={'div'}>
        <Accordion expanded={vitals.accordionOpen}
          onChange={(_, isExpanded) => {
            setVitals((prev) => ({ ...prev, accordionOpen: isExpanded }))
          }}>
          <AccordionSummary className='doc_notes_header_card'expandIcon={<ExpandMoreIcon />}>
            <Typography className='doc_notes_header_card_font'>Vitals</Typography>
          </AccordionSummary>
          <AccordionDetails component={'div'} m={'0.5rem'} border={'1px solid lightgray'}>
            <Table size='small'>
              <TableHead>
                <TableRow>
                  <TableCell className='doc_notes_tbl_header'>Height</TableCell>
                  <TableCell className='doc_notes_tbl_header'>Weight</TableCell>
                  <TableCell className='doc_notes_tbl_header'>BP S</TableCell>
                  <TableCell className='doc_notes_tbl_header'>BP D</TableCell>
                  <TableCell className='doc_notes_tbl_header'>Temp</TableCell>
                  <TableCell className='doc_notes_tbl_header'>SpO2(%)</TableCell>
                  <TableCell className='doc_notes_tbl_header'>Pulse Rate</TableCell>
                  <TableCell className='doc_notes_tbl_header'>Blood Glucose</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {vitals?.vitalData?.length > 0 ? vitals?.vitalData?.map((item, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell className='doc_notes_tbl_body_cell'>
                        {textBox('height_cm', (item?.height_cm ? item?.height_cm : ''), '7dvw', 'cm', index)}
                      </TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>
                        {textBox('weight_kg', (item?.weight_kg ? item?.weight_kg : ''), '7dvw', 'kg', index)}
                      </TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>
                        {textBox('blood_pressure_diastolic', (item?.blood_pressure_diastolic ? item?.blood_pressure_diastolic : ''), '8dvw', 'mm/Hg', index)}
                      </TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>
                        {textBox('blood_pressure_systolic', (item?.blood_pressure_systolic ? item?.blood_pressure_systolic : ''), '8dvw', 'mm/Hg', index)}
                      </TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>
                        {textBox('temperature', (item?.temperature ? item?.temperature : ''), '4dvw', '', index)}
                        <Select
                          sx={{ width: '5vw', height: COMMON_STYLE.HEIGHT }}
                          value={item?.temperature_unit}
                          onChange={(e) => {
                            let value = e.target.value
                            let vitalData = [...vitals.vitalData]
                            vitalData[index] = { ...vitalData[index], temperature_unit: value }
                            setVitals((prev) => ({ ...prev, vitalData: vitalData }))
                          }}
                        >
                          <MenuItem value={'F'}>{'°F'}</MenuItem>
                          <MenuItem value={'C'}>{'°C'}</MenuItem>
                        </Select>
                      </TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>
                        {textBox('pulse_oximetry', (item?.pulse_oximetry ? item?.pulse_oximetry : ''), '7dvw', '%', index)}
                      </TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>
                        {textBox('pulse_rate', (item?.pulse_rate ? item?.pulse_rate : ''), '7dvw', 'min', index)}
                      </TableCell>
                      <TableCell className='doc_notes_tbl_body_cell'>
                        {textBox('blood_sugar', (item?.blood_sugar ? item?.blood_sugar : ''), '8dvw', 'mg/DL', index)}
                      </TableCell>
                    </TableRow>
                  )
                }) : <TableRow><TableCell align='center' colSpan={8}>No Records To Be Shown</TableCell></TableRow>}
              </TableBody>
            </Table>
          </AccordionDetails>
        </Accordion>
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaDocVitals